import React, { useState, useEffect } from "react";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";

const EditAgentModal = ({ show, handleClose, agent, updateAgent }) => {

  const [data, setData] = useState(agent || {});
  const [image, setImage] = useState("/assets/avatar.png");

  useEffect(() => {
    if (agent) {
      setData(agent);
      if (agent.image) setImage(agent.image);
    }
  }, [agent]);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file));
    }
  };

  const save = () => {
    updateAgent({ ...data, image });
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">

      <Modal.Header closeButton>
        <Modal.Title>
          Edit Agent
          <span className="text-muted fs-6 ms-3">
            Agent ID : {agent?.id}
          </span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>

        {/* Upload Image Section */}

        <div
          style={{
            background: "#f6f7f9",
            padding: "15px",
            borderRadius: "8px",
            marginBottom: "20px",
            display: "flex",
            alignItems: "center",
            gap: "15px"
          }}
        >

          <img
            src={image}
            alt=""
            style={{
              width: "70px",
              height: "70px",
              borderRadius: "50%",
              objectFit: "cover"
            }}
          />

          <div>

            <div style={{ fontWeight: "600" }}>
              Upload Profile Image
            </div>

            <div style={{ fontSize: "12px", color: "#777" }}>
              Image should be below 4 mb
            </div>

            <div style={{ marginTop: "8px" }}>

              <input
                type="file"
                id="uploadImg"
                style={{ display: "none" }}
                onChange={handleImageUpload}
              />

              <label
                htmlFor="uploadImg"
                style={{
                  background: "#f26522",
                  color: "#fff",
                  padding: "6px 14px",
                  borderRadius: "5px",
                  cursor: "pointer",
                  marginRight: "10px"
                }}
              >
                Upload
              </label>

              <Button
                size="sm"
                variant="light"
                onClick={() => setImage("/assets/avatar.png")}
              >
                Cancel
              </Button>

            </div>

          </div>

        </div>

        {/* Form Fields */}

        <Row>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>First Name *</Form.Label>
              <Form.Control
                name="firstName"
                value={data.firstName || ""}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                name="lastName"
                value={data.lastName || ""}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Phone Number *</Form.Label>
              <Form.Control
                name="phone"
                value={data.phone || ""}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Email *</Form.Label>
              <Form.Control
                name="email"
                value={data.email || ""}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Department *</Form.Label>
              <Form.Select
                name="department"
                value={data.department || ""}
                onChange={handleChange}
              >
                <option>Select</option>
                <option>Finance</option>
                <option>Support</option>
                <option>HR</option>
                <option>Development</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Designation *</Form.Label>
              <Form.Select
                name="designation"
                value={data.designation || ""}
                onChange={handleChange}
              >
                <option>Select</option>
                <option>Senior Support Agent</option>
                <option>Junior Support Agent</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>About</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="about"
                value={data.about || ""}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

        </Row>

      </Modal.Body>

      <Modal.Footer>

        <Button variant="light" onClick={handleClose}>
          Cancel
        </Button>

        <Button
          style={{
            background: "#f26522",
            border: "none"
          }}
          onClick={save}
        >
          Save
        </Button>

      </Modal.Footer>

    </Modal>
  );
};

export default EditAgentModal;